<template >

    <!--    <el-button class="d2-mr btn-text can-hover" type="text" @click="handleClick">-->
    <!--        <d2-icon name="search" style="font-size: 18px;"/>-->
    <!--    </el-button>-->

    <div class="header-search">

        <!--            <el-input v-model="searchInfo.styleNo" style="width: 150px;margin-left: 30px;" placeholder="款号搜索" >-->
        <!--              <el-button slot="append" icon="el-icon-search"/>-->
        <!--            </el-input>-->

        <!--        <el-input v-model="searchInfo.styleNo" suffix-icon="el-icon-search" type="text" @change="fetchData">款号搜索</el-input>-->

        <el-autocomplete
                popper-class="header-search-select-option"
                v-model="searchInfo.styleNo"
                :fetch-suggestions="querySearchAsync"
                placeholder="款号搜索"
                @select="handleSelect" suffix-icon="el-icon-search" />

    </div>

</template>

<script>
    import {Vue, Prop, Watch} from 'vue-property-decorator';
    import _ from 'lodash';
    import request from '@/util/request';


    export default {
        data() {
            return {
                searchInfo: {
                    styleNo: '',
                },
                list: [],
            }
        },
        mounted() {
            this.fetchData();
        },
        methods: {

            handleClick() {
                this.$emit('click');
            },

            styleNoFilter(queryString) {
                return (result) => {
                    return (result.styleNo.indexOf(queryString) > -1);
                };
            },

            fetchData(){
              if(this.searchInfo.styleNo.length>0){
                request.get('/api/goNode/orders/query_order_styles', {styleNo: this.searchInfo.styleNo}).then(res=>{
                  if(res.status) {
                    this.list = res.list;
                  }
                })
              }
            },
            querySearchAsync(queryString, cb) {

                let results = queryString ? this.list.filter(this.styleNoFilter(queryString)) : this.list;
                let resultsARR = _.map(results, item => {
                    return {
                        ...item,
                        value: item.styleNo,
                    }
                });
                this.timeout = setTimeout(() => {
                    cb(resultsARR);
                }, 1000 * Math.random());
            },
            handleSelect(item) {
                this.$router.push(`/orders/${item.num}`);
                this.searchInfo.styleNo = '';
            },



        }
    }
</script>
<style lang="scss">

    .header-search-select-option{
        width: 200px !important;
    }

    .header-search {
        input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
            color: #606266;
        }
        input:-moz-placeholder, textarea:-moz-placeholder {
            color: #606266;
        }
        input::-moz-placeholder, textarea::-moz-placeholder {
            color: #606266;
        }
        input:-ms-input-placeholder, textarea:-ms-input-placeholder {
            color: #606266;
        }
        .el-input {
            input {
                border-radius: 5px;
                border-style: hidden;
                width: 120px;
                background: rgba(255, 255, 255, 0.5);
                color: black;
            }

            .el-input__suffix {
                margin-top: -9px;
            }
        }

    }

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-search/index.vue"
}
</vue-filename-injector>
